module.exports = __webpack_public_path__ + "img/thmb_03.52439dc0.png";